import React from "react";
import DashboardLeaderboardPanel from "../components/dashboard/DashboardLeaderboardPanel";

const Leaderboard = () => {
  return <DashboardLeaderboardPanel />;
};

export default Leaderboard;
